import React, {useEffect, useRef, useState} from 'react';
import Section from "../../components/section";
import HelperService from "../../services/helper-service";
import MainLayout from "../../layouts/main";
import {useGlobalNotificationMessage} from "../../context/message";
import PageTitle from "../../components/page-title";
import AddEditAttachmentModal from "../attachment/add-edit-attachment-modal";
import {useAttachmentService} from "../../services/attachment-service";
import {AttachmentCategoryTypes, AttachmentTypes, MembershipGalleryAttachmentTypes} from "../../utils/constants";
import Attachment from "../../components/files/attachment";
import {useAttachmentCategoryService} from "../../services/attachment-category-service";


export default function MembershipGalleryList () {
  let attachmentService = useAttachmentService();
  let attachmentCategoryService = useAttachmentCategoryService();
  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();
  const [rows, setRows] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [allowedAttachmentCategories, setAllowedAttachmentCategories] = useState([]);

  const addEditModal = useRef();
  const allowedAttachmentTypes = Object.values(MembershipGalleryAttachmentTypes);

  useEffect(()=>{
    attachmentCategoryService.getTypeList(AttachmentCategoryTypes.membershipGallery.val).then((cats)=>{
        setAllowedAttachmentCategories(cats);
      })
      .catch(error => {
        HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa získať dáta kategórií.");
      })
    attachmentService.getTypeList(AttachmentTypes.membershipGallery.val)
      .then((rows)=>{
        setRows(rows);
        setLoaded(true);
      })
      .catch(error => {
        HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa získať dáta.");
      })
  }, []);

  const onAddEditAction = (row=null, e=null)=>{
    addEditModal.current.openModal(row, allowedAttachmentTypes, allowedAttachmentCategories);
  };

  const onAddEditCallbackAction = (items=null)=>{
    items.map((item)=>{
      setRows(HelperService.addOrReplaceItemInList(rows,item));
    })

  };

  const onAttachmentDelete = (item)=>{
    setRows(HelperService.removeItemFromList(rows, item))
  };

  const onDelAction = (item, e=null)=>{
    if (true===confirm('Naozaj odstrániť záznam?')){
      attachmentService.delModel(item.id)
        .then(()=>{
          setRows(HelperService.removeItemFromList(rows,item));
        })
        .catch(error => {
          HelperService.handleApiErrors(error, addErrorMessage);
        })
    }
  };

  return (
    <>
      <AddEditAttachmentModal ref={addEditModal} onSuccess={(item)=>onAddEditCallbackAction(item)} />

      <Section animation={HelperService.getRandomAnimation()}>
        <div className="container mt-4">

          <PageTitle>Galéria družstva</PageTitle>

          <button className="btn btn-primary mb-2" onClick={(e)=>onAddEditAction(null, e)}><span className="mdi mdi-plus"></span> Pridať</button>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">

                  {rows?.length>0 && <div className="row mt-2">
                    {rows.map((att)=>{
                      return <div key={'att_wrap_'+att.id} className="col-sm-12 col-md-6 col-lg-4">
                        <Attachment attachment={att}
                                    gallery={false}
                                    onDelSuccess={(att)=>onAttachmentDelete(att)}
                                    editAction={(att)=>addEditModal.current.openModal(att, allowedAttachmentTypes, allowedAttachmentCategories)}
                        />
                      </div>;
                    })}
                  </div>}

                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>
    </>
  );
}

MembershipGalleryList.getLayout = function getLayout(page) {
  return (
    <MainLayout>
      {page}
    </MainLayout>
  )
}

MembershipGalleryList.getSEO = function getSEO() {
  return {
    title: "Galéria družstva",
  }
}
